<template>
  <div>
    <div class="day_record_box">
      <div class="day_record_title">写手日结登记</div>
      <el-date-picker
        v-model="timeData"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        @change="timeChange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
    </div>

    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="130px"
      >
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手昵称" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="writer_name">
          <el-input v-model="filter_form.writer_name"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input v-model="filter_form.alipay_account"></el-input>
        </el-form-item>
        <el-form-item label="日结状态" prop="is_settle">
          <el-select v-model="filter_form.is_settle" placeholder="日结状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table height="550"  :data="dataShow" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          width="200"
        ></el-table-column>
        <el-table-column
          property="writer_name"
          label="写手姓名"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="alipay_account"
          label="写手支付宝"
          align="center"
          sortable
          width="120"
        ></el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          align="center"
          sortable
          width="120"
        ></el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          align="center"
          sortable
          width="160"
        ></el-table-column>
        <el-table-column
          property="word_number"
          label="入库字数"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="writer_cost"
          label="给写手的千字价格"
          align="center"
          sortable
          width="200"
        >
        </el-table-column>
        <el-table-column
          property="each_chapter_num"
          label="每章字数"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="manuscript_diff"
          label="差价"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="fee"
          label="实际应收稿费"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="sj_fee"
          label="实际应发稿费"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="deposit_money"
          label="压稿金额"
          align="center"
          sortable
          width="150"
        >
        </el-table-column>

        <el-table-column
          property="frequency"
          label="日结第几天"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="settlement_type"
          label="日周结"
          align="center"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <el-tag :class="scope.row.settlement_type == '2' ? 'week' : 'day'">
              {{ scope.row.settlement_type == "2" ? "周结" : "日结" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="is_settle"
          label="日结状态"
          align="center"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_settle == '0' ? 'info' : 'success'">
              {{ scope.row.is_settle == "0" ? "未结算" : "已结算" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          property="status"
          label="是否通过"
          align="center"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '0'
                  ? ''
                  : scope.row.status == '1'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.status == "0"
                  ? "审查中"
                  : scope.row.status == "1"
                  ? "通过"
                  : "驳回"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="w_qd_remark"
          label="备注"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <div class="control_box">
              <div @click="editDialogBtn(scope.row)" class="writer_day_btn">
                <i class="el-icon-edit-outline"></i>
                备注
              </div>
              <!-- "status": -1,//是否通过:0=审查中,1=通过,-1=驳回 -->
              <div
                @click="rejectDialogBtn(scope.row)"
                class="writer_day_btn"
                :class="[
                  {
                    writer_day_btn: scope.row.status == -1,
                    disabled_btn: scope.row.status == 1 || scope.row.status == 0
                  }
                ]"
              >
                <i class="iconfont icon-jujue"></i>
                驳回查看
              </div>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                multiple
                ref="upload"
                :disabled="showUpload"
                :on-success="uploadFile"
                :show-file-list="false"
              >
                <div
                  class="writer_day_btn"
                  @click="editSubmit(scope.row)"
                  :class="[
                    {
                      writer_day_btn: scope.row.status == -1,
                      disabled_btn:
                        scope.row.status == 1 || scope.row.status == 0
                    }
                  ]"
                >
                  <i class="iconfont icon-kaohe1"></i>
                  修改提交
                </div>
              </el-upload>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 修改备注 -->
    <el-dialog
      title="修改备注"
      width="30%"
      :visible.sync="editDialogVisible"
      center
    >
      <el-form :model="remarkForm" ref="remarkForm">
        <el-form-item label="备注:" prop="w_qd_remark">
          <el-input v-model="remarkForm.w_qd_remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn"
          round
          type="primary"
          @click="handleSetRemark()"
          >确认</el-button
        >
        <el-button class="dialog_btn" round @click="editDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 驳回弹窗 -->
    <el-dialog
      title="驳回查看"
      :visible.sync="rejectDialogVisible"
      width="30%"
      center
    >
      <div class="reject_dialog_box">
        <div class="reject_dialog_title">驳回原因：</div>
        <div class="reject_dialog_content">{{ rejectTxt }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn"
          round
          type="primary"
          @click="rejectDialogVisible = false"
          >确认</el-button
        >
        <el-button class="dialog_btn" round @click="rejectDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  connectionrecord_day_list,
  connectionrecord_day_suggestions,
  reject_file_operate,
  connectionrecord_w_qd_remark
} from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      ownerId: "", //所属写手id
      dayRecordList: [], //日结登记列表
      isFilterForm: true, //筛选表单
      rejectDialogVisible: false, //驳回弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      filterTime: "", //筛选时间
      day_start: "", //开始时间
      day_end: "", //结束时间
      // 筛选
      filter_form: {
        connectionessay_name: "", //书名
        writer_nickname: "", //写手昵称
        writer_name: "", //写手姓名
        alipay_account: "", //写手支付宝
        is_settle: "", //日结状态
        status: "" //是否通过 0=审查中，1=通过，-1=驳回
      },
      rejectTxt: "", //驳回原因
      currentUploadId: "", //文件上传id
      showUpload: false, //弹窗是否显示
      editDialogVisible: false, //备注弹窗
      remarkForm: {
        w_qd_remark: ""
      }, //备注表单
      timeData: [], //时间筛选
      connectionrecord_id: "" //文章id
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getDayRecordList();
  },
  methods: {
    // 获取写手日结登记列表
    getDayRecordList(time, filter) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        createtime: time,
        page: 1,
        page_index: 10,
        ...filter
      };
      connectionrecord_day_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.dayRecordList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 修改备注
    editDialogBtn(val) {
      var that = this;
      that.editDialogVisible = true;
      that.remarkForm = { ...val };
    },
    // 确认修改
    handleSetRemark() {
      var that = this;
      console.log(that.remarkForm);
      let obj = {
        departmentuser_id: that.writerId,
        connectionrecord_id: that.remarkForm.id,
        w_qd_remark: that.remarkForm.w_qd_remark
      };
      connectionrecord_w_qd_remark(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.editDialogVisible = false;
          that.getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 文件上传
    uploadFile(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: that.currentUploadId,
        file: val.data.url,
        connectionrecord_id: that.connectionrecord_id
      };
      reject_file_operate(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 提交修改
    editSubmit(val) {
      // "status": -1,//是否通过:0=审查中,1=通过,-1=驳回
      var that = this;
      var current_status = val.status;
      if (current_status == -1) {
        that.showUpload = false;
        that.currentUploadId = val.connectionessay_id;
        that.connectionrecord_id = val.id;
        this.$message("只能上传doc、docx文件");
      } else if (current_status == 0) {
        that.showUpload = true;
        this.$message.error("审查中,无法修改");
      } else {
        that.showUpload = true;
        this.$message.error("已通过,无法修改");
      }
    },
    // 筛选
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        createtime: that.filterTime,
        ...that.filter_form
      };
      connectionrecord_day_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.dayRecordList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 时间段筛选
    timeChange(val) {
      var that = this;
      that.day_start = val[0];
      that.day_end = val[1];
      that.filterTime = that.day_start + " - " + that.day_end;
      that.goSearch();
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 驳回查看
    rejectDialogBtn(val) {
      var that = this;
      that.rejectDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        connectionrecord_id: val.id
      };

      connectionrecord_day_suggestions(obj).then(res => {
        if (res.data.code == 1) {
          that.rejectTxt = res.data.data;
          getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 计算页数的方法
    calcPageData() {
      if (this.dayRecordList.length > 1) {
        this.pageNum =
          Math.ceil(this.dayRecordList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.dayRecordList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.day_record_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
}
.task_box {
  margin: 0px 15px;
}
.writer_day_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 5px;
}
.day_record_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #ffffff;
  border: 1px solid #e4e9f1;
}

.writer_day_btn i {
  font-size: 12px;
}
.sea_icon {
  font-size: 12px;
}

.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  /* width: 96%; */
  /* height: 100px; */
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.control_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
/* 驳回弹窗 */
.reject_dialog_box {
  width: 400px;
  display: flex;
  flex-direction: row;
  padding: 10px;
}
.reject_dialog_title {
  width: 150px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.reject_dialog_content {
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  padding: 0px 10px;
}
.week {
  background: #f9f1fc;
  color: #af50d7;
}
.day {
  background: #e3f9e9;
  color: #67c23a;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin-right: 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.disabled_btn i {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterDayRecord.vue